import styled from 'styled-components';

import ButtonCircle from '../ButtonCircle';
import { getImageUrl, media } from '../../../../utils';

export const CallButton = styled(ButtonCircle)`
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;

  @media (max-width: 320px) {
    margin: 0 5px;
  }

  @media (max-width: 520px) {
    margin: 0 5px;
  }
`;

export const DialButton = styled(ButtonCircle)`
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid var(--purple-300);
`;

export const VideoDialButton = styled(DialButton)`
  background-image: ${getImageUrl('/icons/ic-video-thumbnail-purple.svg')};
`;

export const AudioDialButton = styled(DialButton)`
  background-color: var(--purple-300);
  background-image: ${getImageUrl('/icons/ic-callkit-audio-20.svg')};
`;

export const VideoCallAcceptButton = styled(CallButton)`
  background-color: #2eba9f;
  background-image: ${getImageUrl('/icons/icon-call-video.svg')};
  &:hover {
    background-color: #007a7a;
  }
`;

export const AudioCallAcceptButton = styled(CallButton)`
  background-color: #2eba9f;
  background-image: ${getImageUrl('/icons/ic-callkit-audio.svg')};
  &:hover {
    background-color: #007a7a;
  }
`;

export const MuteButton = styled(CallButton)`
  background-color: rgba(168, 168, 168, 0.38);
  background-image: ${getImageUrl('/icons/icon-mic-on.svg')};
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

export const ReportButton = styled(CallButton)`
  background-color: rgba(168, 168, 168, 0.38);
  background-image: ${getImageUrl('/icons/icon-report-flag.svg')};
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

export const UnmuteButton = styled(CallButton)`
  background-color: #e53157;
  background-image: ${getImageUrl('/icons/icon-mic-off.svg')};

  &:hover {
    background-color: #f04164;
  }
`;

export const StopVideoButton = styled(CallButton)`
  background-color: rgba(168, 168, 168, 0.38);
  background-image: ${getImageUrl('/icons/icon-video-on.svg')};
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

export const StartVideoButton = styled(CallButton)`
  background-color: #e53157;
  background-image: ${getImageUrl('/icons/icon-video-off.svg')};
  &:hover {
    background-color: #f04164;
  }
`;

export const EndButton = styled.button<{ disabled: boolean }>`
  border: 1px solid #e53157;
  cursor: pointer;
  text-align: justify;
  margin-left: 10px;
  padding: 14.5px 25px;
  border-radius: 15px;
  font-size: 1.6rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  outline: none;

  &:hover {
    background-color: #e53157;
  }

  ${media.tablet`
    padding: 11px 8px;
    font-size: 1.2rem;
  `}

  ${media.mobileL`
    padding: 9px 10px;
    font-size: 1.2rem;
  `}

  @media (max-width: 320px) {
    padding: 9px 7px;
    font-size: 1rem;
    margin-left: 5px;
  }
`;

export const EndButtonIcon = styled(CallButton)<{ disabled: boolean }>`
  background-color: #e53157;
  background-image: ${getImageUrl('/icons/ic-callkit-end.svg')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background-color: #f04164;
  }
`;
